class ArchiveAnnuaire {
  private itemsPerPage = 10;
  private currentIndex = 0;
  private loadMoreBtn;

  constructor() {
    this._init();
  }

  _init() {
    const archive = document.querySelector('.archive-annuaire');
    if (archive) {
      this.loadMoreBtn = document.querySelector('[data-toggle-readmore-annuaire]') as HTMLButtonElement;
      this.showNextItems();
      this.loadMoreBtn.addEventListener('click', () => {
        this.showNextItems();
      });
    }
  }

  public showNextItems() {
    const items = document.querySelectorAll<HTMLDivElement>('.archive-annuaire__list .archive-annuaire__item');
    for (let i = this.currentIndex; i < this.currentIndex + this.itemsPerPage && i < items.length; i++) {
      items[i].classList.add('visible');
    }
    this.currentIndex += this.itemsPerPage;
    if (this.currentIndex >= items.length) {
      this.loadMoreBtn.style.display = 'none';
    }
  }
}

export const archiveAnnuaire = new ArchiveAnnuaire();
